module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive--dark-3ece7ef42eab1f2ce0ed71e793f0d313.png";